import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.admin.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-institute-admin-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.admin.list/view.scss */
/* src/app/portal.institute.admin.list/view.scss: no such file or directory */`],
})
export class PortalInstituteAdminListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public organizations = [];
    public pagenation: any = {
        page: 1,
        end: 1,
        start: 1,
    };

    public dump: any = "10";
    public searchTerm: any;
    public total: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관 관리 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagenation.page, dump: this.dump });
        if (code != 200) return await this.service.alert.error("Error!");
        this.organizations = data.list;
        this.pagenation.start = (parseInt(this.pagenation.page / 11) * 10) + 1;
        this.pagenation.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    public onSelect(org: any) {
        console.log('선택된 기관:', org);
    }

    public dumpChange(dump: string) {
        this.dump = dump;
        this.pagenation.page = 1;
        this.load();
    }

    private async pageLoad(p: number) {
        this.pagenation.page = p;
        await this.load();
    }
}

export default PortalInstituteAdminListComponent;